export default [
  {
    path: '/players',
    name: 'players',
    redirect: '/players/user-data',
    meta: {
      layout: 'players',
      title: 'Кабинет',
      auth: true,
    },
  },
  {
    path: '/players/user-data',
    name: 'user-data',
    component: () => import('@/views/players/user-data.vue'),
    meta: {
      layout: 'players',
      title: 'Кабинет',
      auth: true,
    },
  },
  {
    path: '/players/my-teams',
    name: 'my-teams',
    component: () => import('@/views/players/my-teams.vue'),
    meta: {
      layout: 'players',
      title: 'Кабинет',
      auth: true,
    },
  },
  {
    path: '/players/my-games',
    name: 'my-games',
    component: () => import('@/views/players/my-games.vue'),
    meta: {
      layout: 'players',
      title: 'Кабинет',
      auth: true,
    },
  },
  {
    path: '/players/my-teams/:memberId',
    name: 'teamMemberInfo',
    props: true,
    component: () => import('@/views/players/team-layout/memberInfo'),
    meta: {
      layout: 'players',
      title: 'Информация об игроке',
      auth: true,

    },
  },
  {
    path: '/players/my-teams/additional-info/:teamId',
    name: 'additional-info',
    props: true,
    component: () => import('@/views/players/team-layout/additional-info'),
    meta: {
      layout: 'players',
      title: 'Дополнительная информация',
      auth: true,

    },
  },
];
